var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReasignar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.43 20.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .59px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 4.5,
    cy: 11.91,
    rx: 1.82,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.82,
    y1: 18.17,
    x2: 6.82,
    y2: 20.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.29,
    y1: 18.13,
    x2: 2.29,
    y2: 20.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.46,14.96h0c2.3,0,4.16,1.86,4.16,4.16v.68c0,.25-.2.45-.45.45H.74c-.25,0-.45-.2-.45-.45v-.68c0-2.3,1.86-4.16,4.16-4.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 14.01,
    cy: 2.4,
    rx: 1.82,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.33,
    y1: 8.66,
    x2: 16.33,
    y2: 10.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.81,
    y1: 8.62,
    x2: 11.81,
    y2: 10.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.97,5.44h0c2.3,0,4.16,1.86,4.16,4.16v.68c0,.25-.2.45-.45.45h-7.43c-.25,0-.45-.2-.45-.45v-.68c0-2.3,1.86-4.16,4.16-4.16Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.5 7.37 4.5 2.4 9.19 2.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 9.19,
    cy: 2.4,
    r: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.99,
    y: 6.97,
    width: 1.02,
    height: 1.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.74 12.58 14.74 17.55 10.05 17.55"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10.05,
    cy: 17.55,
    r: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.23,
    y: 11.95,
    width: 1.02,
    height: 1.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasignar);
export default __webpack_public_path__ + "static/media/Reasignar.c1c211c63458d8f741420d435b0c3a26.svg";
export { ForwardRef as ReactComponent };